import { cond, constant, isEqual } from 'lodash/fp'
import FormikInput from 'shared/components/Input/FormikInput'
import styled from 'styled-components'

export enum FieldType {
  FullName,
  StreetAddress,
  UnitNumber,
  City,
  ZipCode,
  CountryRegion,
  Telephone,
  State,
}

interface IAddressFormField {
  title: string
  name: string
  type: FieldType
  disabled?: boolean
  qaAttr?: string
}

const StyledInput = styled(FormikInput)`
  margin-bottom: 16px;
`

const AddressFormField = ({ title, name, type, disabled, qaAttr }: IAddressFormField) => {
  const inputProps = cond([
    [
      isEqual(FieldType.FullName),
      constant({
        autoComplete: 'name',
        type: 'text',
      }),
    ],
    [
      isEqual(FieldType.StreetAddress),
      constant({
        autoComplete: 'street-address',
        type: 'text',
      }),
    ],
    [
      isEqual(FieldType.UnitNumber),
      constant({
        type: 'text',
      }),
    ],
    [
      isEqual(FieldType.City),
      constant({
        autoComplete: 'address-level2',
        type: 'text',
      }),
    ],
    [
      isEqual(FieldType.ZipCode),
      constant({
        autoComplete: 'postal-code',
        type: 'text',
      }),
    ],
    [
      isEqual(FieldType.Telephone),
      constant({
        autoComplete: 'tel',
        type: 'text',
      }),
    ],
  ])(type)

  return (
    <StyledInput title={title} name={name} qaAttr={qaAttr} disabled={disabled} {...inputProps} />
  )
}

export default AddressFormField
